export default __webpack_public_path__ + "static/media/8.a7f03ed7.jpg";